import { observer } from "mobx-react";
import React, { useState, useEffect } from "react";
import { Stack, TextInput, Button, Loader } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";

interface EditNostrConnectionForReceiveOnlyProps {
  cubby: Cubby;
}

const EditNostrConnectionForReceiveOnly = observer(
  ({ cubby }: EditNostrConnectionForReceiveOnlyProps) => {
    const connection = cubby.selectedNostrConnection;

    if (!connection) {
      return null;
    }

    const [isLoading, setIsLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      connection.setName(e.currentTarget.value);
      setHasChanges(true);
    };

    const handleSaveConnection = () => {
      cubby.cubbyFastInfo("modify_nwc_connection", {
        nostrConnectionUuid: connection.uuid,
        name: connection.name,
        budgetAmountSats: null,
        budgetRenewalPeriodDays: null,
        connectionExpirationDays: null,
      });

      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        cubby.setModal(MODALS.CONNECT_APPS);
        setHasChanges(false);
      }, 3000);
    };

    return (
      <Stack gap="md">
        <TextInput
          label="Name"
          value={connection.name}
          onChange={handleNameChange}
        />
        {isLoading ? (
          <Loader />
        ) : (
          <Button onClick={handleSaveConnection} disabled={!hasChanges}>
            Save Connection
          </Button>
        )}
      </Stack>
    );
  }
);

export default EditNostrConnectionForReceiveOnly;
